const INVENTORY_TYPE_ID = 1
const SERVICE_TYPE_ID = 2
const CASEMANAGER_TYPE_ID = 3

export default {
  schedules: {
    INVENTORY_TYPE_ID: INVENTORY_TYPE_ID,
    SERVICE_TYPE_ID: SERVICE_TYPE_ID,
    CASEMANAGER_TYPE_ID: CASEMANAGER_TYPE_ID
  }
}



// WEBPACK FOOTER //
// ./src/config/consts.js